import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const routes: AdminRoute[] = [{ to: "/admin/power-bi/settings", name: "Settings" }];

export const Route = createFileRoute("/_authenticated/_admin/admin/power-bi")({
    component: Component,
});

function Component() {
    return (
        <>
            <AdminRouteSelector routes={routes} />
            <Box width={"100%"} mt={2}>
                <Outlet />
            </Box>
        </>
    );
}
